import { Star } from "lucide-react";

/** Compact star display. rating = { avg, count } | null */
export default function RatingStars({ rating, size = 14, showEmpty = false, className = "" }) {
  const count = rating?.count || 0;
  if (!count && !showEmpty) return null;
  const avg = rating?.avg || 0;
  const full = Math.round(avg);
  return (
    <span className={"inline-flex items-center gap-1 text-slate-700 " + className} title={`${avg}★ · ${count} rating${count === 1 ? "" : "s"}`}>
      <span className="inline-flex">
        {[1, 2, 3, 4, 5].map(i => (
          <Star key={i} size={size} className={i <= full ? "fill-amber-400 text-amber-400" : "text-slate-300"} />
        ))}
      </span>
      <span className="text-xs text-slate-500">{count ? `${avg.toFixed(1)} · ${count}` : "New"}</span>
    </span>
  );
}
